// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1067c529","167":"794659d4","455":"b0748933","696":"7f051d39"}[chunkId] + ".chunk.js";
};